import React, { useState, useRef, useEffect } from "react";
import { buildApiUrl, API_ENDPOINTS, APP_DISPLAY_NAME } from "../../config/api";

const MfaCodeModal = ({ tempToken, onSuccess, onExpired }) => {
  const [code, setCode]               = useState("");
  const [isBackupMode, setIsBackupMode] = useState(false);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [isBackupMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      setError(
        isBackupMode
          ? "Ingresa tu código de respaldo."
          : "Ingresa el código de 6 dígitos."
      );
      return;
    }

    setLoading(true);
    setError("");

    try {
      const body = isBackupMode
        ? { tempToken, backupCode: code.trim() }
        : { tempToken, code: code.trim() };

      const res = await fetch(buildApiUrl(API_ENDPOINTS.mfaValidate), {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (res.ok) {
        onSuccess(data);
      } else if (res.status === 401) {
        onExpired();
      } else {
        setError(data.message || "Código incorrecto. Intenta de nuevo.");
      }
    } catch {
      setError("Error de conexión. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setIsBackupMode((prev) => !prev);
    setCode("");
    setError("");
  };

  return (
    <>
      <div className="login-logo">
        <img src="/LOGOCETIUCLOGIN.png" alt={APP_DISPLAY_NAME} />
      </div>

      <h2 className="login-title">Verificación en dos pasos</h2>
      <p className="login-subtitle">
        {isBackupMode
          ? "Ingresa uno de tus códigos de respaldo para continuar."
          : "Abre tu app autenticadora e ingresa el código de 6 dígitos."}
      </p>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-field">
          <label htmlFor="mfa-code">
            {isBackupMode ? "Código de respaldo" : "Código de verificación"}
          </label>
          <input
            ref={inputRef}
            id="mfa-code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder={isBackupMode ? "A3F2C1B4D5" : "123456"}
            autoComplete="one-time-code"
            maxLength={isBackupMode ? 12 : 6}
          />
          {error && <span className="login-error">{error}</span>}
        </div>

        <button
          type="submit"
          className="login-submit-btn"
          disabled={loading}
        >
          {loading ? "Verificando..." : "Verificar"}
        </button>
      </form>

      <button
        type="button"
        className="login-secondary-link"
        style={{ marginTop: "16px" }}
        onClick={toggleMode}
      >
        {isBackupMode
          ? "Volver al código de la app autenticadora"
          : "¿No tienes acceso a tu app? Usar un código de respaldo"}
      </button>
    </>
  );
};

export default MfaCodeModal;
